const DASHBOARD_ICON_MAP: Record<string, string> = {
  'AI Metrics': 'light:brain-circuit',
  Adoption: 'light:arrow-up-right-dots',
  Usage: 'light:chart-line-up',
  Leaderboards: 'light:ranking-star',
}

const DEFAULT_DASHBOARD_ICON = 'light:chart-pie'

export default function useDashboardIcon() {
  function getDashboardIcon(name: string): string {
    return DASHBOARD_ICON_MAP[name] ?? DEFAULT_DASHBOARD_ICON
  }

  return { getDashboardIcon }
}
